import React from "react";
import "./HeroCarousel.css"; // Import the updated CSS

const HeroCarousel = () => {
    return (
        <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
            {/* Indicators */}
            <div className="carousel-indicators d-none">
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>

            {/* Carousel Items */}
            <div className="carousel-inner">
                {/* Slide 1 */}
                <div className="carousel-item active" data-bs-interval="3000">
                    <img src="http://researchdiscourse.org/wp-content/uploads/2021/05/slide1-1.jpg" className="d-block w-100" alt="Slide 1" />
                    <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <h1>EASY TO PUBLISH YOUR ARTICLES</h1>
                        <p>Research Discourse: A Peer-reviewed Refereed Research Journal.</p>
                        <div className="d-flex gap-3">
                            <a href="#" className="btn btn-warning btn-lg">Get Started Now</a>
                            <a href="#" className="btn btn-dark btn-lg">Read More</a>
                        </div>
                    </div>
                </div>

                {/* Slide 2 */}
                <div className="carousel-item" data-bs-interval="3000">
                    <img src="http://researchdiscourse.org/wp-content/uploads/2021/05/slide1-1.jpg" className="d-block w-100" alt="Slide 2" />
                    <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <h1>JOIN OUR RESEARCH COMMUNITY</h1>
                        <p>Connect with experts and contribute to research.</p>
                        <div className="d-flex gap-3">
                            <a href="#" className="btn btn-warning btn-lg">Submit Article</a>
                            <a href="#" className="btn btn-dark btn-lg">Learn More</a>
                        </div>
                    </div>
                </div>

                {/* Slide 3 */}
                <div className="carousel-item" data-bs-interval="3000">
                    <img src="http://researchdiscourse.org/wp-content/uploads/2021/05/slide1-1.jpg" className="d-block w-100" alt="Slide 3" />
                    <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <h1>EXPAND YOUR RESEARCH IMPACT</h1>
                        <p>Get recognized in the academic world.</p>
                        <div className="d-flex gap-3">
                            <a href="#" className="btn btn-warning btn-lg">Publish Now</a>
                            <a href="#" className="btn btn-dark btn-lg">View Journals</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Controls */}
            <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
            </button>
        </div>
    );
};

export default HeroCarousel;
